import React__default from 'react';

var FooterInfoSpan = function (_a) {
    var text = _a.text, _b = _a.lessOpacity, lessOpacity = _b === void 0 ? false : _b;
    return React__default.createElement("span", { className: lessOpacity ? 'pgc-game-footer-id' : 'pgc-game-footer-id-text' }, text);
};

export { FooterInfoSpan };
